import { Box } from '@mui/material'
import { styled } from '@mui/system'

export const ModalBase = styled(Box)(() => ({
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 656,
  maxHeight: 920,
  height: 'auto',
  backgroundColor: 'white',
}))
